import { Link } from "react-router-dom";
import type { Episode } from "@/types";

interface EpisodeCardProps {
  episode: Episode;
  rank?: number;
}

export default function EpisodeCard({ episode, rank }: EpisodeCardProps) {
  return (
    <Link
      to={`/detail/${episode.id}`}
      className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 sm:flex-row sm:p-4"
    >
      <div className="relative w-full overflow-hidden rounded-md sm:w-[210px] sm:flex-shrink-0">
        <div className="aspect-video w-full overflow-hidden rounded-md bg-background-200">
          <img
            src={episode.cover}
            alt={`出轨同学会第${episode.number}集《${episode.title}》剧照`}
            title={`出轨同学会 第${episode.number}集 ${episode.title} 剧情介绍`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <span className="absolute left-2 top-2 rounded bg-primary-900/85 px-2 py-0.5 font-label text-[11px] leading-tight text-background-50">
          第 {episode.number} 集
        </span>
      </div>

      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-heading text-base font-semibold text-foreground-900 transition-colors group-hover:text-primary-700">
            {episode.title}
          </h3>
          {typeof rank === "number" && (
            <span className="font-heading text-lg italic leading-none text-background-400">
              {String(rank).padStart(2, "0")}
            </span>
          )}
        </div>

        <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 font-label text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-calendar-line text-[13px] leading-none"></i>
            </span>
            {episode.airDate}
          </span>
          <span className="flex items-center gap-1.5">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-time-line text-[13px] leading-none"></i>
            </span>
            {episode.duration}
          </span>
        </div>

        <p className="mt-2.5 line-clamp-2 font-label text-sm leading-relaxed text-foreground-600">
          {episode.summary}
        </p>

        <div className="mt-3 flex flex-wrap gap-2">
          {episode.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-[11px] text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}